import type { Mentorship } from "@/lib/api/mentorships";

export function recordUsesSupportChat(user: {
  systemRoles?: string[];
  is_supervisor?: boolean;
}): boolean {
  const roles = user.systemRoles ?? [];
  return (
    roles.includes("mentor") ||
    roles.includes("lead_mentor") ||
    roles.includes("supervisor") ||
    Boolean(user.is_supervisor)
  );
}

/**
 * Active mentorship for a teen record's Show Chat action.
 * Mentors and supervisors use the support chat instead.
 */
export function resolveMessageChannel(
  mentorships: Mentorship[] | undefined,
): string | null {
  const active = mentorships?.find((item) => !item.deactivated);
  return active?.mentorship_id ?? null;
}
